import { CloudSyncOutlined } from '@ant-design/icons';
import { Badge, Button } from 'antd';
import { useState } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { SynchronizationDrawer } from 'business/tunnel/pages/ring-scan/components/synchronization-drawer';
import { RingSelector } from 'business/tunnel/pages/ring-scan/components/ring-selector';
import { type Ring, db } from 'technical/db';

interface Props {
  rings: Ring[];
  lastRealRingNumber: number;
  selectedRingId: string | null;
  onRingChange: (ringId: string) => void;
}

export const TunnelHeader = ({
  rings,
  lastRealRingNumber,
  selectedRingId,
  onRingChange,
}: Props) => {
  const [open, setOpen] = useState(false);

  const pendingCount = useLiveQuery(() =>
    db.segments.filter((segment) => segment.desynchronizedAt !== null).count(),
  );

  return (
    <>
      <span className="flex h-12 w-full gap-2">
        <RingSelector
          rings={rings}
          lastRealRingNumber={lastRealRingNumber}
          selectedRingId={selectedRingId}
          onRingChange={onRingChange}
        />
        <Badge count={pendingCount}>
          <Button
            onClick={() => setOpen(true)}
            type="primary"
            icon={<CloudSyncOutlined className="text-3xl" />}
            className="size-14 shrink-0"
          />
        </Badge>
      </span>
      <SynchronizationDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
};
